import { createSelector } from 'reselect';

export const selectJobOrderDetailState = (state) => state?.jobOrderDetailState;

export const selectIsJobOrderDetailLoadingV2 = createSelector(
  selectJobOrderDetailState,
  (s) => s?.isJobOrderDetailLoading || false
);

export const selectJobOrderDetailV2 = createSelector(
  selectJobOrderDetailState,
  (s) => s?.jobOrderDetail || {}
);

export const selectIsJobOrderDetailUpdatedV2 = createSelector(
  selectJobOrderDetailState,
  (s) => s?.isJobOrderDetailUpdated || false
);

export const selectIsRosterActionProcessingV2 = createSelector(
  selectJobOrderDetailState,
  (s) => s?.isRosterActionProcessing || false
);

export const selectIsCancelProcessingV2 = createSelector(
  selectJobOrderDetailState,
  (s) => s?.isCancelProcessing || false
);

export const selectIsCancelSeriesProcessingV2 = createSelector(
  selectJobOrderDetailState,
  (s) => s?.isCancelSeriesProcessing || false
);

export const selectCancelledPlacement = createSelector(
  selectJobOrderDetailState,
  (s) => s?.cancelledPlacement || {}
);

export const selectIsCancelledPlacementLoading = createSelector(
  selectJobOrderDetailState,
  (s) => s?.isCancelledPlacementLoading || false
);
